import * as React from "react";
import "./Upload.scss";

export interface IUploadList {
    onChange: (fileList: FileList) => void;
    fileList: FileList;
}

export const UploadList = ({ onChange, fileList }: IUploadList): JSX.Element => {
    const onRemove = (name: string) => {
        if (!fileList.length) {
            return;
        }

        const dt = new DataTransfer();
        Array.from(fileList).map((file) => file.name !== name && dt.items.add(file));
        onChange(dt.files);
    };

    return (
        <div className="files-list">
            {fileList && fileList.length
                ? Array.from(fileList).map((file) => (
                      <span className="file-block" key={file.name}>
                          <span className="file-delete" onClick={() => onRemove(file.name)}>
                              <span className="icon-conexus-close-popup"></span>
                          </span>
                          <a
                              className="name"
                              href={URL.createObjectURL(file)}
                              rel="noopener noreferrer"
                              target="_blank"
                          >
                              {file.name}
                          </a>
                      </span>
                  ))
                : null}
        </div>
    );
};
